import { FormikField } from '@ahmdigital/ui';
import { toLower } from 'lodash/fp';

import { URLS } from '../../../../../../models/url/constants';
import { VariantType } from '../../../../../../types/variant';
import getFrequencyOptions from '../../../../../../utils/get-frequency-options';

const frequencyOptions = getFrequencyOptions({ endText: 'ly', format: toLower });

type PaymentFrequencyFieldProps = {
  label?: string;
  location: {
    pathname: string;
  };
  variant?: VariantType;
};

const PaymentFrequencyField = ({ label = 'I want to pay', location, variant }: PaymentFrequencyFieldProps) => {
  if (location?.pathname === URLS.SALES.TAX) {
    return null;
  }
  return (
    <FormikField
      inputVariant={[variant, 'button', 'fullWidth']}
      label={label}
      name="frequency"
      options={frequencyOptions}
      size="auto"
      type="dropdown"
    />
  );
};

export default PaymentFrequencyField;
